var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEnterFullscreen = function SvgEnterFullscreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "-2 -2 44 44"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M13.333 5H6.667C5.747 5 5 5.746 5 6.667v6.666m30 0V6.667C35 5.747 34.254 5 33.333 5h-6.666m0 30h6.666c.92 0 1.667-.746 1.667-1.667v-6.666m-30 0v6.666C5 34.253 5.746 35 6.667 35h6.666"
  })));
};
export default SvgEnterFullscreen;